import { render, staticRenderFns } from "./stock-row.vue?vue&type=template&id=97b28a36&"
import script from "./stock-row.vue?vue&type=script&lang=js&"
export * from "./stock-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports